import React from 'react';
import PropTypes from 'prop-types';
import { ContactUsContent } from './ContactUsContent';

export const ContactUs = ({ isContentLoaded }) => {
  return (
    <Choose>
      <When condition={isContentLoaded}>
        <ContactUsContent />
      </When>
    </Choose>
  );
};

ContactUs.propTypes = {
  isContentLoaded: PropTypes.bool,
};

ContactUs.defaultProps = {
  isContentLoaded: false,
};
